import React from 'react';
import { Calculator, Check, Info } from 'lucide-react';

/**
 * Компонент для выбора формулы расчета максимального пульса
 */
const FormulaSelectionSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  mhrFormulas 
}) => {
  return (
    <div className="mb-6">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Calculator className="w-5 h-5 mr-2 text-red-500" />
        Формула расчета максимального пульса
      </h3>

      <div className="bg-gray-50 dark:bg-gray-800/50 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
        <div className="grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3">
          {mhrFormulas.map((formula) => (
            <label 
              key={formula.id}
              className={`
                relative flex flex-col p-4 border rounded-lg cursor-pointer
                ${formData.formula === formula.id 
                  ? 'bg-red-50 border-red-300 dark:bg-red-900/20 dark:border-red-700' 
                  : 'bg-white border-gray-200 hover:bg-gray-50 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700'}
              `}
            >
              <input
                type="radio"
                name="formula"
                value={formula.id}
                checked={formData.formula === formula.id}
                onChange={handleInputChange}
                className="absolute opacity-0 h-0 w-0"
              />
              <div className="flex items-start gap-3">
                {formData.formula === formula.id && (
                  <Check className="w-5 h-5 text-red-500 shrink-0" />
                )}
                <div className={formData.formula === formula.id ? 'ml-0' : 'ml-5'}>
                  <div className="font-medium text-gray-800 dark:text-gray-200">
                    {formula.name} 
                    {formula.recommended && (
                      <span className="ml-2 inline-block text-xs px-2 py-0.5 bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400 rounded-full">
                        Рекомендуемая
                      </span>
                    )}
                  </div>
                  <div className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                    {formula.description}
                  </div>
                  <div className="text-xs text-gray-500 dark:text-gray-500 mt-1">
                    Год публикации: {formula.year}
                  </div>
                </div>
              </div>
            </label>
          ))}
        </div>

        {errors.formula && (
          <p className="mt-3 text-sm text-red-500 dark:text-red-400">
            {errors.formula}
          </p>
        )}

        {/* Подсказка о формулах */}
        <div className="mt-4 p-3 bg-amber-50 dark:bg-amber-900/20 border border-amber-100 dark:border-amber-800 rounded-lg flex items-start">
          <Info className="w-5 h-5 text-amber-500 mt-0.5 mr-3 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-medium text-amber-800 dark:text-amber-300 mb-1">
              Какую формулу выбрать?
            </h4>
            <p className="text-xs text-amber-700 dark:text-amber-400">
              Формула Танаки (208 - 0.7 × возраст) считается наиболее точной для общего населения. Для женщин может быть точнее формула Гулати. 
              Классическая формула "220 - возраст" (Хаскелла-Фокса) имеет наибольшую погрешность, но остаётся самой известной из-за простоты запоминания. 
              Точность всех формул снижается для профессиональных спортсменов и людей старше 65 лет.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormulaSelectionSection;